export default "__VITE_ASSET__HQvFswJD__"